export class SuperadminApiError extends Error {
  status: number;
  code?: string;
  /** Detalhe cru devolvido pelo provider, quando a edge repassa (ex.: erro da UAZAPI). */
  detail?: string;

  constructor(message: string, status: number, code?: string, detail?: string) {
    super(message);
    this.name = 'SuperadminApiError';
    this.status = status;
    this.code = code;
    this.detail = detail;
  }

  get isForbidden(): boolean {
    return this.status === 401 || this.status === 403;
  }
}
